<template>
  <div>
    <v-dialog
      max-width="550px"
      max-height="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Day Off
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <h3>Date of Day Off</h3>
              <DatePicker
                v-model="currentDayOff.EventDate"
                @onDatePickerChange="onChange(currentDayOff.EventDate)"
              />
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h3>Description</h3>
              <v-text-field
                v-model="currentDayOff.EventDescription"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.prevent="saveDayOff" :disabled="disableSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: 'DaysOffEditor',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: false
    },
    currentDayOff: {
      required: false,
      default: null
    },
    addMode: {
      required: false,
      default: false
    },
    daysoff: {
      required: false,
      default: []
    }
  },
  data () {
    return {
      disableSave: false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    date: {
      get () {
        return this.currentDayOff.EventDate
      },
      set (val) {
        this.$emit('input', val || null)
      }
    }
  },
  mounted () {
  },
  methods: {
    saveDayOff () {
      this.disableSave = true
      if (this.addMode) {
        const body = {
          EventDate: this.currentDayOff.EventDate,
          EventDescription: this.currentDayOff.EventDescription
        }
        this.axios.post('/api/dayoff', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.daysoff.push(res.data[0])
          this.disableSave = false
          this.show = false
          this.$store.dispatch('setSuccess', { successMsg: 'Day off succesefully added' })
        }).catch(error => {
          this.disableSave = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.axios.put(`/api/daysoff/${this.currentDayOff.ID}`, this.currentDayOff, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          for (let i = 0; i < this.daysoff.length; i++) {
            if (this.daysoff[i].ID === this.currentDayOff.ID) {
              this.daysoff[i].EventDate = this.currentDayOff.EventDate
              this.daysoff[i].EventDescription = this.currentDayOff.EventDescription
              break
            }
          }
          this.disableSave = false
          this.show = false
          this.$store.dispatch('setSuccess', { successMsg: 'Day off succesefully updated' })
        }).catch(error => {
          this.disableSave = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    onChange (date) {
      this.date = date
    }
  }
}
</script>
